import { lazy } from 'react'

export const Support = lazy(() => import('./Support'))
